import api from '../../api'
const recurrenceAPI = api.create('recurrence')

const transfer = async (accountId) => {
    return await recurrenceAPI.get(`/api/users/login_with_token/` + accountId )
}
export default {
  transfer
}